import { ReferenceTypeV4 } from "@/domain/entities/BookingV4";

interface ClientReferenceValue {
  value: string;
  type: string;
}

export const getClientShipmentId = (
  references: ClientReferenceValue[] = []
): string => {
  const shipmentReference = references.find(
    (chip) => chip.type === ReferenceTypeV4.SHIPMENT_ID
  );

  return shipmentReference?.value.trim() || "";
};
